import { render, staticRenderFns } from "./ChildSafetyStandards.vue?vue&type=template&id=61a00912&scoped=true&"
import script from "./ChildSafetyStandards.vue?vue&type=script&lang=js&"
export * from "./ChildSafetyStandards.vue?vue&type=script&lang=js&"
import style0 from "./ChildSafetyStandards.vue?vue&type=style&index=0&id=61a00912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a00912",
  null
  
)

export default component.exports